import { render, staticRenderFns } from "./no-records-yes.vue?vue&type=template&id=31b6aa3d"
import script from "./no-records-yes.vue?vue&type=script&lang=js"
export * from "./no-records-yes.vue?vue&type=script&lang=js"
import style0 from "./no-records-yes.vue?vue&type=style&index=0&id=31b6aa3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports